import React from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from './form'

const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'libelle',
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Relation')}</strong>,
  type: 'string',
}, {
  header: EurestoI18n.t('commun:Abrégé'),
  id: 'abrege',
  type: 'string',
}]

export default React.memo(props => <Formulaire defaultObject={{
  abrege: undefined, libelle: undefined, actif: 1
}} title={EurestoI18n.t('commun:Relation')} columnSearch={'id'} form={<Template/>} module={Constants.module.CRM} requete={Constants.donnee.relation} columns={columns}/>)


// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/Relation/index.js